import React, { Component } from "react";
import Gallery2018 from "./Gallery2018";
import Gallery2017 from "./Gallery2017";
import Gallery2016 from "./Gallery2016";


export default class Gallery extends Component {

  renderOld() {
      return (
            <div>
                <div className="container">
                    <div >Retnet India Event Gallery</div>
                </div>
                <div className="container text-center">
                    <button className="btn btn-info gallery-btn"> 2016 Event Gallery</button>
                    <button className="btn btn-info gallery-btn"> 2017 Event Gallery</button>
                    <button className="btn btn-success gallery-btn"> 2018 Event Gallery</button>
                </div>
                <br />
                <div className="container-fluid">
                    <div className="row cols-md-space cols-sm-space cols-xs-space">
                        <div className="col-lg-4">
                            <div className="card z-depth-2-top">
                                <div className="card-image">
                                    <div className="view view-first">
                                        <a href="/">
                                            <img src="/images/about01.jpg" />
                                        </a>
                                    </div>
                                </div>


                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="card z-depth-2-top">
                                <div className="card-image">
                                    <div className="view view-first">
                                        <a href="#">
                                            <img src="/images/about02.jpg" />
                                        </a>
                                    </div>
                                </div>


                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="card z-depth-2-top">
                                <div className="card-image">
                                    <div className="view view-first">
                                        <a href="#">
                                            <img src="/images/about03.jpg" />
                                        </a>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>

                    <div className="row cols-md-space cols-sm-space cols-xs-space">
                        <div className="col-lg-4">
                            <div className="card z-depth-2-top">
                                <div className="card-image">
                                    <div className="view view-first">
                                        <a href="#">
                                            <img src="/images/about01.jpg" />
                                        </a>
                                    </div>
                                </div>


                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="card z-depth-2-top">
                                <div className="card-image">
                                    <div className="view view-first">
                                        <a href="#">
                                            <img src="/images/about02.jpg" />
                                        </a>
                                    </div>
                                </div>


                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="card z-depth-2-top">
                                <div className="card-image">
                                    <div className="view view-first">
                                        <a href="#">
                                            <img src="/images/about03.jpg" />
                                        </a>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>

                    <div className="row cols-md-space cols-sm-space cols-xs-space">
                        <div className="col-lg-4">
                            <div className="card z-depth-2-top">
                                <div className="card-image">
                                    <div className="view view-first">
                                        <a href="#">
                                            <img src="/images/about01.jpg" />
                                        </a>
                                    </div>
                                </div>


                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="card z-depth-2-top">
                                <div className="card-image">
                                    <div className="view view-first">
                                        <a href="#">
                                            <img src="/images/about02.jpg" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="card z-depth-2-top">
                                <div className="card-image">
                                    <div className="view view-first">
                                        <a href="#">
                                            <img src="/images/about03.jpg" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

      );
  }

  render(){
    return(
      <div className="container">
      <div className="tabs tabs--style-1 tabs--centered" role="tabpanel">
        <div className="row">
            <div className="col-md-2"></div>

            <div className="col-md-8">
                  <ul className="nav nav-pills nav-pills--rounded" role="tablist">
                      <li className="nav-item" role="presentation">
                          <a href="#tabThree-1" aria-controls="home" role="tab" data-toggle="tab" className="nav-link active text-center text-uppercase strong-500">
                              <div className="nav-pill">
                                  <span className="nav-pill-circle">2018</span>
                                  <span className="nav-pill-text text-caps strong-500">Gallery</span>
                              </div>
                          </a>
                      </li>
                      <li className="nav-item" role="presentation" className="">
                          <a href="#tabThree-2" aria-controls="home" role="tab" data-toggle="tab" className="nav-link text-center text-uppercase strong-500">
                              <div className="nav-pill">
                                  <span className="nav-pill-circle">2017</span>
                                  <span className="nav-pill-text text-caps strong-500">Gallery</span>
                              </div>
                          </a>
                      </li>
                      <li className="nav-item" role="presentation" className="">
                          <a href="#tabThree-3" aria-controls="home" role="tab" data-toggle="tab" className="nav-link text-center text-uppercase strong-500">
                              <div className="nav-pill">
                                  <span className="nav-pill-circle">2016</span>
                                  <span className="nav-pill-text text-caps strong-500">Gallery</span>
                              </div>
                          </a>
                      </li>
                  </ul>

            </div>

            <div className="col-md-2"></div>

        </div>


          <div className="tab-content no-border">
              <div role="tabpanel" className="tab-pane active" id="tabThree-1">
                  <div className="tab-body">
                      <Gallery2018 />
                  </div>
              </div>
              <div role="tabpanel" className="tab-pane" id="tabThree-2">
                  <div className="tab-body">
                     <Gallery2017 />
                  </div>
              </div>
              <div role="tabpanel" className="tab-pane" id="tabThree-3">
                  <div className="tab-body">
                     <Gallery2016 />
                  </div>
              </div>
          </div>
      </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/Gallery.js